import client from './client';

export const submitContactForm = async (contactData) => {
    const { data } = await client.post('/api/content/contact', contactData);
    return data;
};

export const subscribeNewsletter = async (email) => {
    const { data } = await client.post('/api/content/newsletter', { email });
    return data;
};

export const getContent = async (type) => {
    // For now, we return null so the frontend uses static content if the backend doesn't have it
    try {
        const { data } = await client.get(`/api/content?type=${type}`);
        return data;
    } catch (err) {
        return null;
    }
};
